import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Nav } from '../components/Nav';
import { Footer } from '../components/Footer';

export function NotFound() {
  return (
    <div
      style={{
        background: 'var(--paper)',
        color: 'var(--ink)',
        fontFamily: 'var(--font-mono)',
        minHeight: '100vh',
        fontSize: 12,
        lineHeight: 1.55,
      }}
    >
      <TopBar />
      <Nav />
      <section className="section" style={{ padding: '96px 28px', minHeight: '50vh' }}>
        <div className="eyebrow" style={{ marginBottom: 16 }}>
          § · Out of bounds
        </div>
        <h1
          className="serif italic"
          style={{ fontSize: 'var(--fs-display)', lineHeight: 0.95, letterSpacing: -1.8, margin: 0 }}
        >
          Nothing filed here.
        </h1>
        <div className="serif italic" style={{ fontSize: 19, marginTop: 20, opacity: 0.75 }}>
          The dossier index doesn't have a record at this address.
        </div>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            marginTop: 28,
            fontSize: 10.5,
            textTransform: 'uppercase',
            letterSpacing: 1.5,
            textDecoration: 'none',
            borderBottom: '1px solid var(--ink)',
            paddingBottom: 2,
          }}
        >
          ← return to dossier
        </Link>
      </section>
      <Footer />
    </div>
  );
}
